export const spiritualMaalaLevelTwo = [
    {
        "parentCategoryId": "spiritual_maala",
        "level": 2,
        "name": "Maala",
        "categoryId": "maala"
    },
    {
        "parentCategoryId": "spiritual_maala",
        "level": 2,
        "name": "Divine Items",
        "categoryId": "divine_items"
    }

]
